// Admin section landing page.  Navigation now lives in the side-nav
// rendered by <AdminLayout>; this page is the welcome card shown when
// the URL is exactly /admin.

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";
import { useAuth } from "@/lib/AuthContext";
import { adminStationAssignmentsApi } from "@/lib/api";

export default function AdminHome() {
  const { t } = useTranslation();
  const { user, hasPermission } = useAuth();
  const showStationAssign = hasPermission("station.assign");

  const pendingAssignments = useQuery({
    queryKey: ["admin", "station-assignments", "pending", "count"],
    queryFn: () => adminStationAssignmentsApi.listPending(),
    enabled: showStationAssign,
    refetchInterval: 30_000,
    select: (rows) => rows.length,
  });

  return (
    <>
      <PageHeader
        eyebrow="admin"
        title={t("adminHome.title")}
        description={
          user?.name
            ? t("adminHome.welcomeNamed", { name: user.name })
            : t("adminHome.welcome")
        }
      />

      {showStationAssign && (pendingAssignments.data ?? 0) > 0 && (
        <section className="card p-4 mt-2 border-warn">
          <p className="text-sm">
            <span className="pill pill-warn font-mono mr-2">
              {pendingAssignments.data}
            </span>
            {t("adminHome.pendingAssignments")}{" "}
            <Link to="/admin/station-assignments" className="text-accent-strong underline">
              {t("adminHome.goToReview")}
            </Link>
            .
          </p>
        </section>
      )}
    </>
  );
}
